import { Component, OnInit, inject } from '@angular/core';
import { Router, RouterLink } from "@angular/router";
import { TranslateModule } from '@ngx-translate/core';
import { SearchInputComponent } from '../../pages/search-page/search-input/search-input.component';

@Component({
    selector: 'xplorer-bowser-hero',
    templateUrl: './hero.component.html',
    styleUrls: ['./hero.component.css'],
    imports: [RouterLink, SearchInputComponent, TranslateModule]
})
export class HeroComponent implements OnInit {

  private router: Router = inject(Router);


  ngOnInit(): void {
  }

  searchClicked(inputText: string) {
    this.router.navigate(['search'], { queryParams: { name: inputText } });
  }

}
